import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { Newspaper, ArrowRight } from 'lucide-react';

import api from '@/lib/axios';

export default function NewsHomeBlock() {
  const [data, setData] = useState(null);

  useEffect(() => {
    api.get('/marketplace/news/home-block').then((r) => setData(r.data)).catch(() => setData({ tem_conteudo: false }));
  }, []);

  if (!data || !data.tem_conteudo) return null; // oculto quando não há conteúdos publicados

  const featured = data.featured;
  const items = (data.items || []).filter((a) => !featured || a.slug !== featured.slug).slice(0, 3);

  return (
    <section className="border-t border-slate-100 bg-white py-12" data-testid="home-news-block">
      <div className="mx-auto max-w-6xl px-4">
        <div className="flex items-end justify-between">
          <div>
            <span className="inline-flex items-center gap-1.5 text-xs font-bold uppercase tracking-wide text-emerald-600"><Newspaper className="h-4 w-4" /> Centro de Informação TVDE</span>
            <h2 className="mt-1 text-2xl font-extrabold text-slate-900">Notícias, legislação e guias</h2>
          </div>
          <Link to="/noticias-tvde" className="hidden items-center gap-1 text-sm font-bold text-emerald-700 hover:underline sm:inline-flex" data-testid="home-news-all">Ver tudo <ArrowRight className="h-4 w-4" /></Link>
        </div>

        <div className="mt-6 grid gap-4 lg:grid-cols-3">
          {featured && (
            <Link to={`/noticias-tvde/artigo/${featured.slug}`} className="flex flex-col justify-between rounded-2xl border border-emerald-200 bg-gradient-to-br from-emerald-50 to-white p-6 shadow-sm transition hover:shadow-md lg:row-span-1" data-testid="home-news-featured">
              <div>
                <span className="inline-flex rounded-full bg-emerald-600 px-2.5 py-1 text-[11px] font-bold text-white">Destaque</span>
                <h3 className="mt-3 text-xl font-extrabold leading-snug text-slate-900">{featured.titulo}</h3>
                {featured.resumo && <p className="mt-2 line-clamp-3 text-sm text-slate-600">{featured.resumo}</p>}
              </div>
              <span className="mt-4 inline-flex items-center gap-1 text-sm font-bold text-emerald-700">Ler <ArrowRight className="h-4 w-4" /></span>
            </Link>
          )}
          {items.map((a) => (
            <Link key={a.slug} to={`/noticias-tvde/artigo/${a.slug}`} className="rounded-2xl border border-slate-200 bg-white p-5 shadow-sm transition hover:border-emerald-300" data-testid={`home-news-item-${a.slug}`}>
              {a.categoria && <span className="text-[11px] font-semibold text-slate-400">{a.categoria.replace(/-/g, ' ')}</span>}
              <h3 className="mt-1 font-extrabold leading-snug text-slate-900">{a.titulo}</h3>
              {a.resumo && <p className="mt-1 line-clamp-2 text-sm text-slate-600">{a.resumo}</p>}
            </Link>
          ))}
        </div>
        <Link to="/noticias-tvde" className="mt-6 inline-flex items-center gap-1 text-sm font-bold text-emerald-700 hover:underline sm:hidden">Ver tudo <ArrowRight className="h-4 w-4" /></Link>
      </div>
    </section>
  );
}
